/*
 * Post-address.ts
 * Description: Includes the declaration of a function
 * to create a new home address for the user
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';
// Importing interface
import {Address} from '@/ts/profile/addresses/validate-address';

/**
 * Creating a new user address
 *
 * @param {String[]} errors - register errors
 * @param {Address} data - address data
 * @return {Object} Promise - when the request is resolved
 */
export function postAddress(errors: string[], data: Address) {
    const jwt = localStorage.getItem('jwt');
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'addresses',
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data,
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
